<template>
    <div>
        <div>
            <product-variant v-model="selected" v-for="variant in variants" :input-value="variant.value" :key="variant.name" :price="variant.price">
                {{ variant.variant }}
            </product-variant>
            <div class="variant-radio">
                <div class="variant-radio__price font-title text-3xl">
                    <small>&pound;</small>{{ current.price }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
            },
            variants: {
                type: Array,
            }
        },
        data() {
            return {
                selected: null,
            }
        },
        created() {
            this.selected = this.variants[0].value;
            console.log(this.selected)
        },
        computed: {
            current() {
                let current;
                this.variants.forEach(v => {
                    if (v.value == this.selected) {
                        current = v;
                    }
                });
                return current;
            }
        }
    }
</script>

<style scoped>

</style>